import apiService from '@/state/services/Api'

const users = {
  namespaced: true,
  state: {
    pk: 'user_uuid',
    groups: [],
    roles: [],
    fields: {
      email: { label: 'email', type: 'email' },
    }
  },
  getters: {
    pk(state) {
      return state.pk
    },
    roleTypes(state) {
      const roles = state.roles.reduce(
          (acc, role) => [...acc, { id: Object.keys(role)[0], name: Object.values(role)[0] }],
          []
      )
      return roles
    },
    groupTypes(state) {
      return state.groups
    },
    sonicoProfiles() {
      return [
        {
          id: '01',
          name: 'Customer',
        },
        {
          id: '02',
          name: 'Admin Customer',
        },
        {
          id: '03',
          name: 'GWF Technician',
        },
        {
          id: '04',
          name: 'ENG/Production',
        },
      ]
    },
    editFields(state) {
      return state.fields
    },
    createFields(state, getters, rootState, rootGetters) {
      const company = {
        label: 'company',
        type: 'select',
        rules: ['required'],
        options: rootGetters['companies/list'],
      }
      const role = {
        label: 'role',
        type: 'select',
        rules: ['required'],
        options: getters['roleTypes'],
      }
      const sonico_profile = {
        label: 'sonico_profile',
        type: 'select',
        rules: ['required'],
        options: getters['sonicoProfiles'],
      }
      const groups = {
        label: 'role',
        type: 'select',
        rules: ['required'],
        options: getters['groupTypes'],
      }
      if (rootGetters['auth/isStaff']) {
        return { ...state.fields, role, sonico_profile, company }
      }
      return { ...state.fields, role, company }
    }
  },
  mutations: {
    SET_GROUPS(state, payload) {
      state.groups = payload.results
    },
    SET_ROLES(state, payload) {
      state.roles = payload
    },
  },
  actions: {
    get(context) {
      return apiService.query(`users`).then((data) => {
        return data
      })
    },

    getUser(context, id) {
      return apiService.get(`users/${id}`).then((data) => {
        return data
      })
    },

    getProfiles(context, id) {
      return apiService.get(`users/${id}/profiles`).then((data) => {
        return data
      })
    },

    editProfiles({ state }, { id, profileId, permissions }) {
      return apiService.patch(`users/${id}/profiles/${profileId}`, { permissions }).then((data) => {
        return data
      })
    },

    getGroups({ state, commit }) {
      return apiService
          .fetch(`/authsystem/groups`)
          .then((data) => {
            commit('SET_GROUPS', data)
            return data
          })
          .catch((err) => {
            console.warn(err)
          })
    },

    getRoles({ state, commit }) {
      return apiService
          .fetch(`/authsystem/roles`)
          .then((data) => {
            commit('SET_ROLES', data)
            return data
          })
          .catch((err) => {
            console.warn(err)
          })
    },

    sendResetPassword(context, payload) {
      return apiService.post(`users/reset_request`, payload).then((data) => {
        return data
      })
    },

    getActivationToken(context, { id, token }) {
      return apiService.get(`users/${id}/set_password/${token}`).then((data) => {
        return data
      })
    },

    activateUser({ rootState }, payload) {
      return apiService
          .post(`users/${rootState.route.params.id}/set_password/${rootState.route.params.token}`, payload)
          .then((data) => {
            return data
          })
    },

    getResetToken(context, { id, token }) {
      return apiService.get(`users/${id}/set_password/${token}`).then((data) => {
        return data
      })
    },

    resetPassword({ rootState }, payload) {
      return apiService
          .post(`users/${rootState.route.params.id}/set_password/${rootState.route.params.token}`, payload)
          .then((data) => {
            return data
          })
    },

    create({ state }, payload) {
      return apiService.post(`users`, payload).then((data) => {
        return data
      })
    },

    changeGroups({ state }, user) {
      return apiService.post(`users/${user[state.pk]}/change_group`, { groups: user.groups }).then((data) => {
        return data
      })
    },

    setCompanies({ state }, user) {
      return apiService.post(`users/${user[state.pk]}/change_companies`, { companies: user.company }).then((data) => {
        return data
      })
    },

    changeRole({ state }, user) {
      return apiService.post(`users/${user[state.pk]}/change_role`, { role: user.role }).then((data) => {
        return data
      })
    },

    assignSonico({ state }, user) {
      return apiService
          .post(`users/${user[state.pk]}/assign_sonico_profile`, { sonico_profile: user.sonico_profile })
          .then((data) => {
            return data
          })
    },

    edit({ state }, user) {
      return apiService.patch(`users/${user[state.pk]}`, user).then((data) => {
        return data
      })
    },

    delete({ state }, user) {
      return apiService.delete(`users/${user[state.pk]}`).then((data) => {
        return data
      })
    },

    resendActivationToken({ state }, user) {
      return apiService.post(`users/${user[state.pk]}/resend_activation`).then((data) => {
        return data
      })
    },
  }
}

export default users
